import { Component } from '@angular/core';
import { NavGroup } from '../../components/side-nav/side-nav.component';

@Component({
    templateUrl: './payroll-situation.template.html',
    styleUrls: ['../../self-serve.style.scss'],
})
export class PayrollSituationView {
    navGroups: NavGroup[] = [];

    constructor() {
        this.setNavGroups();
    }

    private setNavGroups(): void {
        const navGroups: NavGroup[] = [
            {
                title: 'self-serve.payrollSituation.tellUsAboutYourPayrollSituation',

                steps: [
                    {
                        text: 'self-serve.payrollSituation.sideNav.tellUsAboutYourPayrollSituation',
                        href: 'tell-us',
                        complete: true,
                    },
                    {
                        text: 'self-serve.payrollSituation.sideNav.addYourPayrollTimeline',
                        href: 'timeline',
                        complete: true,
                    },
                ],
            },
        ];

        this.navGroups = navGroups;
    }
}
